import { render, staticRenderFns } from "./FarmPageConnectedWallet.vue?vue&type=template&id=6bb86d13&"
import script from "./FarmPageConnectedWallet.vue?vue&type=script&lang=js&"
export * from "./FarmPageConnectedWallet.vue?vue&type=script&lang=js&"
import style0 from "./FarmPageConnectedWallet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports